import React from 'react';
import { Content, Heading, IllustratedMessage, Link, Text } from "@react-spectrum/s2";
import { Trans, useTranslation } from 'react-i18next';
import { LockCloseIllustration as Unauthorized } from '../icons/s2';
import { APP_NAME } from '../../constants';
const ADOBE_SUPPORT_EMAIL = 'guides-knowledgeai@adobe.com';
export interface NoReadAccessViewProps {
    /** Email of the org's longest-standing org_admin, or null if the org has none yet. */ orgAdminEmail?: string | null;
    /** Display name of that org_admin, if set (may equal the email). */ orgAdminName?: string | null;
}
/** 403 gate shown after /ensure when the user holds no role in the org yet. */ export const NoReadAccessView: React.FC<NoReadAccessViewProps> = ({ orgAdminEmail, orgAdminName })=>{
    const { t } = useTranslation();
    return (<div className={" sd171 _ta171 eb171 _Ca171 _ub171 _vb171 _sb171 Tk171 Qk171 Sk171 Rk171"}>
    <IllustratedMessage>
      <Unauthorized/>
      <Heading>{t('settings.noReadAccess.heading')}</Heading>
      <Content>
        {orgAdminEmail ? (<Text>
            <Trans i18nKey="settings.noReadAccess.requestSent" values={{
        appName: APP_NAME,
        admin: orgAdminName?.trim() || orgAdminEmail
    }} components={{
        adminLink: <Link href={`mailto:${orgAdminEmail}`}>{orgAdminName?.trim() || orgAdminEmail}</Link>
    }}/>
          </Text>) : (<Text>
            {t('settings.noReadAccess.notified')}
          </Text>)}
      </Content>
    </IllustratedMessage>
  </div>);
};

import "macro-f76cc1ef15cd6d54c97f93a73408d439fd34270cb299908fb3f83f733f28cade.css";